import type { HTMLAttributes, ReactNode } from 'react';

import { ClassNames } from '@/shared/classNames';

type CardProperties = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const Card = ({ children, className, ...properties }: CardProperties) => (
  <section className={ClassNames('border-line bg-panel min-w-0 rounded-lg border', className)} {...properties}>
    {children}
  </section>
);

export const CardHeader = ({ children, className, ...properties }: CardProperties) => (
  <div className={ClassNames('border-line min-w-0 border-b px-4 py-3', className)} {...properties}>
    {children}
  </div>
);

export const CardTitle = ({ children, className, ...properties }: CardProperties) => (
  <h2 className={ClassNames('text-ink text-sm font-semibold tracking-[-0.01em]', className)} {...properties}>
    {children}
  </h2>
);

export const CardContent = ({ children, className, ...properties }: CardProperties) => (
  <div className={ClassNames('min-w-0 p-4', className)} {...properties}>
    {children}
  </div>
);
